import styledComponents from 'styled-components';

const TextWithParagraphs = styledComponents.div<{}>`
      display: block;
      position: relative;
      white-space: pre-line;
`;

export default TextWithParagraphs;
